/* TypeScript file generated from Corporate.res by genType. */
/* eslint-disable import/first */


import * as React from 'react';

const $$toRE810408759: { [key: string]: any } = {"Show": 0, "Hide": 1};

// @ts-ignore: Implicit any on import
import * as CorporateBS__Es6Import from './Corporate.bs';
const CorporateBS: any = CorporateBS__Es6Import;

import type {Amplitude_pageViewTracker as Tracking_Amplitude_pageViewTracker} from '../../src/provider/Tracking.gen';

import type {Amplitude_userActionTracker as Tracking_Amplitude_userActionTracker} from '../../src/provider/Tracking.gen';

import type {Corporate_corporateStyle as Atom_Cta_Corporate_corporateStyle} from '../../src/design-system/atom/Atom_Cta.gen';

import type {Status_t as User_Type_Status_t} from '../../src/user/User_Type.gen';

import type {alternativeLanguages as Context_I18n_alternativeLanguages} from '../../src/provider/Context_I18n.gen';

import type {api as Context_Config_api} from '../../src/provider/Context_Config.gen';

import type {appGalleryUrl as Context_Config_appGalleryUrl} from '../../src/provider/Context_Config.gen';

import type {appStoreUrl as Context_Config_appStoreUrl} from '../../src/provider/Context_Config.gen';

import type {ariaLabel as Particle_Accessibility_ariaLabel} from '../../src/design-system/particle/Particle_Accessibility.gen';

import type {createVideoElement as Context_Config_createVideoElement} from '../../src/provider/Context_Config.gen';

import type {displayOverFooter as Organism_Footer_displayOverFooter} from '../../src/design-system/organism/footer/Organism_Footer.gen';

import type {displayedSubHeaders as Organism_Header_displayedSubHeaders} from '../../src/design-system/organism/header/Organism_Header.gen';

import type {emacPage as Type_Category_emacPage} from '../../src/type/Type_Category.gen';

import type {env as User_Api_env} from '../../src/user/User_Api.gen';

import type {formaters as Context_I18n_formaters} from '../../src/provider/Context_I18n.gen';

import type {id as Type_Organism_Menu_id} from '../../src/type/Type_Organism_Menu.gen';

import type {image as Organism_Carousel_Corporate_image} from '../../src/design-system/organism/carousel/Organism_Carousel_Corporate.gen';

import type {jsEntry as FeatureFlipping_jsEntry} from '../../src/FeatureFlipping.gen';

import type {language as Type_Common_language} from '../../src/type/Type_Common.gen';

import type {link as Type_Organism_Menu_link} from '../../src/type/Type_Organism_Menu.gen';

import type {mode as Type_Header_mode} from '../../src/type/Type_Header.gen';

import type {more as Type_Organism_Menu_more} from '../../src/type/Type_Organism_Menu.gen';

import type {onButtonClick as Molecule_LanguageSwitcher_onButtonClick} from '../../src/design-system/molecule/Molecule_LanguageSwitcher.gen';

import type {oneTimeEvent as Type_Header_oneTimeEvent} from '../../src/type/Type_Header.gen';

import type {playStoreUrl as Context_Config_playStoreUrl} from '../../src/provider/Context_Config.gen';

import type {programTrackingHandler as Tracking_programTrackingHandler} from '../../src/provider/Tracking.gen';

import type {search as Organism_Header_search} from '../../src/design-system/organism/header/Organism_Header.gen';

import type {search as Type_Organism_Menu_search} from '../../src/type/Type_Organism_Menu.gen';

import type {serverTime as Context_Config_serverTime} from '../../src/provider/Context_Config.gen';

import type {t as Emac_Footer_t} from '../../src/emac/Emac_Footer.gen';

import type {t as Emac_Menus_t} from '../../src/emac/Emac_Menus.gen';

import type {t as Type_Translation_t} from '../../src/generated/Type_Translation.gen';

import type {vodStoreHomepageUrl as Context_Config_vodStoreHomepageUrl} from '../../src/provider/Context_Config.gen';

// tslint:disable-next-line:interface-over-type-literal
export type I18nProvider_Props = {
  readonly children: React.ReactNode; 
  readonly formaters: Context_I18n_formaters; 
  readonly labels: Type_Translation_t; 
  readonly locale: Type_Common_language; 
  readonly loginUrl?: string; 
  readonly myArteBaseUrl?: string; 
  readonly profileUrl?: string
};

export const I18nProvider: React.FC<{
  readonly children: React.ReactNode; 
  readonly formaters: Context_I18n_formaters; 
  readonly labels: Type_Translation_t; 
  readonly locale: Type_Common_language; 
  readonly loginUrl?: string; 
  readonly myArteBaseUrl?: string; 
  readonly profileUrl?: string
}> = function Corporate_I18nProvider(Arg1: any) {
  const $props = {children:Arg1.children, formaters:{addFavorite:Arg1.formaters.addFavorite, availabilityDate:(Arg1.formaters.availabilityDate == null ? Arg1.formaters.availabilityDate : function (Arg11: any) {
      const result1 = Arg1.formaters.availabilityDate({type:Arg11.type_, start:Arg11.start});
      return result1
    }), betweenDates:(Arg1.formaters.betweenDates == null ? Arg1.formaters.betweenDates : function (Arg12: any) {
      const result2 = Arg1.formaters.betweenDates({start:Arg12.start, end:Arg12.end_});
      return result2
    }), date:Arg1.formaters.date, dateWithFormat:Arg1.formaters.dateWithFormat, nextBroadcastDate:Arg1.formaters.nextBroadcastDate, nextEpisode:Arg1.formaters.nextEpisode, progress:Arg1.formaters.progress, removeFavorite:Arg1.formaters.removeFavorite, watchTrailer:Arg1.formaters.watchTrailer, weekInterval:Arg1.formaters.weekInterval, infoSelectedDay:Arg1.formaters.infoSelectedDay, formValidationStringMin:Arg1.formaters.formValidationStringMin, formValidationStringMax:Arg1.formaters.formValidationStringMax}, labels:Arg1.labels, locale:Arg1.locale, loginUrl:Arg1.loginUrl, myArteBaseUrl:Arg1.myArteBaseUrl, profileUrl:Arg1.profileUrl};
  const result = React.createElement(CorporateBS.I18nProvider, $props);
  return result
};

// tslint:disable-next-line:interface-over-type-literal
export type ConfigProvider_Props = {
  readonly api?: Context_Config_api; 
  readonly appGalleryUrl: Context_Config_appGalleryUrl; 
  readonly appStoreUrl: Context_Config_appStoreUrl; 
  readonly baseUrl: string; 
  readonly cdnUrl?: string; 
  readonly children: React.ReactNode; 
  readonly createVideoElement?: Context_Config_createVideoElement; 
  readonly featureFlippings?: FeatureFlipping_jsEntry; 
  readonly playStoreUrl: Context_Config_playStoreUrl; 
  readonly serverTime?: Context_Config_serverTime; 
  readonly ssoApiKey?: string; 
  readonly ssoTokenApiKey?: string; 
  readonly trackPageView: (null | undefined | Tracking_Amplitude_pageViewTracker); 
  readonly trackPixel: (null | undefined | Tracking_programTrackingHandler); 
  readonly trackUserAction: (null | undefined | Tracking_Amplitude_userActionTracker); 
  readonly vodStoreHomepageUrl: Context_Config_vodStoreHomepageUrl
};

export const ConfigProvider: React.FC<{
  readonly api?: Context_Config_api; 
  readonly appGalleryUrl: Context_Config_appGalleryUrl; 
  readonly appStoreUrl: Context_Config_appStoreUrl; 
  readonly baseUrl: string; 
  readonly cdnUrl?: string; 
  readonly children: React.ReactNode; 
  readonly createVideoElement?: Context_Config_createVideoElement; 
  readonly featureFlippings?: FeatureFlipping_jsEntry; 
  readonly playStoreUrl: Context_Config_playStoreUrl; 
  readonly serverTime?: Context_Config_serverTime; 
  readonly ssoApiKey?: string; 
  readonly ssoTokenApiKey?: string; 
  readonly trackPageView: (null | undefined | Tracking_Amplitude_pageViewTracker); 
  readonly trackPixel: (null | undefined | Tracking_programTrackingHandler); 
  readonly trackUserAction: (null | undefined | Tracking_Amplitude_userActionTracker); 
  readonly vodStoreHomepageUrl: Context_Config_vodStoreHomepageUrl
}> = function Corporate_ConfigProvider(Arg1: any) {
  const $props = {api:(Arg1.api == null ? undefined : {loadNextPage:Arg1.api.loadNextPage, isTeaserAvailable:Arg1.api.isTeaserAvailable, getNextPageUrl:(Arg1.api.getNextPageUrl == null ? undefined : function (Arg11: any, Arg2: any) {
      const result1 = Arg1.api.getNextPageUrl(Arg11, Arg2);
      return (result1 == null ? undefined : result1)
    }), getPageUrl:(Arg1.api.getPageUrl == null ? undefined : function (Arg12: any, Arg21: any) {
      const result2 = Arg1.api.getPageUrl(Arg12, Arg21);
      return (result2 == null ? undefined : result2)
    }), getTrailerUrl:Arg1.api.getTrailerUrl, showPrivacyCenter:Arg1.api.showPrivacyCenter, subscribeToNewsletter:(Arg1.api.subscribeToNewsletter == null ? undefined : function (Arg13: any, Arg22: any, Arg3: any) {
      const result3 = Arg1.api.subscribeToNewsletter(Arg13, Arg22, Arg3);
      return result3.then(function _element($promise: any) { return $promise.tag==="Ok"
        ? {TAG: 0, _0:$promise.value} as any
        : {TAG: 1, _0:$promise.value} as any})
    }), onLogoutCallback:Arg1.api.onLogoutCallback, consentStatus:Arg1.api.consentStatus}), appGalleryUrl:Arg1.appGalleryUrl, appStoreUrl:Arg1.appStoreUrl, baseUrl:Arg1.baseUrl, cdnUrl:Arg1.cdnUrl, children:Arg1.children, createVideoElement:(Arg1.createVideoElement == null ? undefined : function (ArgplaySetter: any, ArgpauseSetter: any, ArgvideoKind: any, ArgvideoUrl: any, ArgonPlayerReady: any, ArgpreviewImage: any) {
      const result4 = Arg1.createVideoElement({playSetter:ArgplaySetter, pauseSetter:ArgpauseSetter, videoKind:ArgvideoKind, videoUrl:ArgvideoUrl, onPlayerReady:ArgonPlayerReady, previewImage:ArgpreviewImage});
      return result4
    }), featureFlippings:Arg1.featureFlippings, playStoreUrl:Arg1.playStoreUrl, serverTime:Arg1.serverTime, ssoApiKey:Arg1.ssoApiKey, ssoTokenApiKey:Arg1.ssoTokenApiKey, trackPageView:Arg1.trackPageView, trackPixel:Arg1.trackPixel, trackUserAction:Arg1.trackUserAction, vodStoreHomepageUrl:Arg1.vodStoreHomepageUrl};
  const result = React.createElement(CorporateBS.ConfigProvider, $props);
  return result
};

export const UserProvider: <T1>(_1:{ readonly children: T1; readonly env?: User_Api_env }) => T1 = CorporateBS.UserProvider;

/** 
 * @remarks needed to reset styles
 * @example
 * ```javascript
 *  import { globalStyle } from '@artegeie/design-system/corporate'
 *  const App = () => { globalStyle() }
 * ```
  */
export const globalStyle: (withFont:boolean) => void = CorporateBS.globalStyle;

// tslint:disable-next-line:interface-over-type-literal
export type Header_Props = {
  readonly category?: Type_Category_emacPage; 
  readonly displayedSubHeaders?: Organism_Header_displayedSubHeaders; 
  readonly forcedUserStatus?: User_Type_Status_t; 
  readonly isFixed?: boolean; 
  readonly languages?: Context_I18n_alternativeLanguages; 
  readonly logoBerne?: boolean; 
  readonly menuItems?: Emac_Menus_t; 
  readonly mode?: Type_Header_mode; 
  readonly onClick?: Molecule_LanguageSwitcher_onButtonClick; 
  readonly oneTimeEvent?: (null | undefined | Type_Header_oneTimeEvent); 
  readonly search?: Organism_Header_search
};

/** 
 * @remarks You have to have `I18nProvider`, `UserProvider` and `ConfigProvider` above in your
 * components' tree
 * @see {@link I18nProvider}
 * @see {@link UserProvider}
 * @see {@link ConfigProvider}
 * @example
 * ```javascript
 *  import { Header, ConfigProvider, I18nProvider, UserProvider } from '@artegeie/design-system/corporate'
 *
 *  const App = () =>
 *    <ConfigProvider baseUrl={...}>
 *       <I18nProvider locale={...} labels={...} alternativeLanguages={...}>
 *          <UserProvider user={...} ssoBaseUrl={...}>
 *            <Header {...props} />
 *          </UserProvider>
 *       </I18nProvider>
 *    </ConfigProvider>
 * ```
 *
  */
export const Header: React.FC<{
  readonly category?: Type_Category_emacPage; 
  readonly displayedSubHeaders?: Organism_Header_displayedSubHeaders; 
  readonly forcedUserStatus?: User_Type_Status_t; 
  readonly isFixed?: boolean; 
  readonly languages?: Context_I18n_alternativeLanguages; 
  readonly logoBerne?: boolean; 
  readonly menuItems?: Emac_Menus_t; 
  readonly mode?: Type_Header_mode; 
  readonly onClick?: Molecule_LanguageSwitcher_onButtonClick; 
  readonly oneTimeEvent?: (null | undefined | Type_Header_oneTimeEvent); 
  readonly search?: Organism_Header_search
}> = function Corporate_Header(Arg1: any) {
  const $props = {category:Arg1.category, displayedSubHeaders:Arg1.displayedSubHeaders, forcedUserStatus:Arg1.forcedUserStatus, isFixed:Arg1.isFixed, languages:Arg1.languages, logoBerne:Arg1.logoBerne, menuItems:Arg1.menuItems, mode:Arg1.mode, onClick:Arg1.onClick, oneTimeEvent:(Arg1.oneTimeEvent == null ? undefined : (Arg1.oneTimeEvent == null ? undefined : Arg1.oneTimeEvent)), search:Arg1.search};
  const result = React.createElement(CorporateBS.Header, $props);
  return result
};

// tslint:disable-next-line:interface-over-type-literal
export type Footer_Props = {
  readonly displayOverFooter?: Organism_Footer_displayOverFooter; 
  readonly footerItems?: Emac_Footer_t; 
  readonly newsletterSource?: string
};

/** 
 * @remarks You have to have `I18nProvider` and `ConfigProvider` above in your
 * components' tree
 * @see {@link I18nProvider}
 * @see {@link ConfigProvider}
 * @example
 * ```javascript
 *  import { Footer, ConfigProvider, I18nProvider } from '@artegeie/design-system/corporate'
 *
 *  const App = () =>
 *    <ConfigProvider api={...}>
 *       <I18nProvider locale={...}>
 *         <Footer {...props} newsletterSource={...} footerItems={...} />
 *       </I18nProvider>
 *    </ConfigProvider>
 * ```
 *
  */
export const Footer: React.FC<{
  readonly displayOverFooter?: Organism_Footer_displayOverFooter; 
  readonly footerItems?: Emac_Footer_t; 
  readonly newsletterSource?: string
}> = function Corporate_Footer(Arg1: any) {
  const $props = {displayOverFooter:(Arg1.displayOverFooter == null ? undefined : $$toRE810408759[Arg1.displayOverFooter]), footerItems:Arg1.footerItems, newsletterSource:Arg1.newsletterSource};
  const result = React.createElement(CorporateBS.Footer, $props);
  return result
};

// tslint:disable-next-line:interface-over-type-literal
export type Carousel_Props = {
  readonly id: string; 
  readonly images: Organism_Carousel_Corporate_image[]; 
  readonly label: string; 
  readonly layout?: 
    "Inside"
  | "Outside"
};

/** 
*@example
*```javascript
* import { Carousel } from '@artegeie/desing-system/corporate'
*
* const images = [
*   {
*     alt: "Image 1",
*     copyright: "(c) copyright",
*     src: "https://picsum.photos/720/406",
*     title: "Image 1",
*   },
*   { ... },
* ]
*
* const App = () => {
*   <Carousel
*     id="id-000"
*     theme="Dark"
*     layout="Outside"
*     label="carousel_corporate"
*     images={images}
*   />
* }
*```
 */
export const Carousel: React.FC<{
  readonly id: string; 
  readonly images: Organism_Carousel_Corporate_image[]; 
  readonly label: string; 
  readonly layout?: 
    "Inside"
  | "Outside"
}> = CorporateBS.Carousel;

// tslint:disable-next-line:interface-over-type-literal
export type Button_Props = {
  readonly label: string; 
  readonly onClick?: (_1:MouseEvent) => void; 
  readonly variant?: Atom_Cta_Corporate_corporateStyle
};

export const Button: React.FC<{
  readonly label: string; 
  readonly onClick?: (_1:MouseEvent) => void; 
  readonly variant?: Atom_Cta_Corporate_corporateStyle
}> = CorporateBS.Button;

// tslint:disable-next-line:interface-over-type-literal
export type Menu_Props = {
  readonly buttonMore: Type_Organism_Menu_more; 
  readonly currentLinkId?: Type_Organism_Menu_id; 
  readonly links: Type_Organism_Menu_link[]; 
  readonly navLabel: Particle_Accessibility_ariaLabel; 
  readonly search?: Type_Organism_Menu_search
};

/** 
 * @example
 * ```javascript
 *  import { Menu } from '@artegeie/design-system/corporate'
 *
 *  const App = () =>
 *    <Menu {...props} />
 * ```
 *
  */
export const Menu: React.FC<{
  readonly buttonMore: Type_Organism_Menu_more; 
  readonly currentLinkId?: Type_Organism_Menu_id; 
  readonly links: Type_Organism_Menu_link[]; 
  readonly navLabel: Particle_Accessibility_ariaLabel; 
  readonly search?: Type_Organism_Menu_search
}> = CorporateBS.Menu;
